/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sortingchoosefield2Inputs */

const en__field_sortingchoosefield2 = /** @type {(inputs: _Field_Sortingchoosefield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select field`)
};

const de__field_sortingchoosefield2 = /** @type {(inputs: _Field_Sortingchoosefield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feld auswählen`)
};

/**
* | output |
* | --- |
* | "Select field" |
*
* @param {_Field_Sortingchoosefield2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sortingchoosefield2 = /** @type {((inputs?: _Field_Sortingchoosefield2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sortingchoosefield2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sortingchoosefield2(inputs)
	return de__field_sortingchoosefield2(inputs)
});
export { _field_sortingchoosefield2 as "_field_sortingChooseField" }